import moment from 'moment-timezone';
import React, { useEffect, useState } from 'react';
import DatePicker from 'react-datepicker';
import { useNavigate, useOutletContext } from 'react-router-dom';
import styled from 'styled-components';
import StoreController, {
  CurrentStoreContext,
  EditCouponType,
} from '../../../controller/StoreController';
import { useToast } from '../../../controller/ToastController';
import { getNumberToString } from '../../../utils/util';

const CouponEdit = () => {
  const navigate = useNavigate();
  const showToast = useToast();
  const { currentStore } = useOutletContext<CurrentStoreContext>();

  const [name, setName] = useState<string>('');
  const [discountType, setDiscountType] = useState<number>(0);
  const [discountPrice, setDiscountPrice] = useState<string>('');
  const [discountPercent, setDiscountPercent] = useState<string>('');
  const [maxDiscount, setMaxDiscount] = useState<string>('');

  const [startDate, setStartDate] = useState<Date>(new Date());
  const [endDate, setEndDate] = useState<Date>(new Date());

  const [isLimit, setIsLimit] = useState<number>(0);
  const [couponCount, setCouponCount] = useState<string>('');
  const [isMinPrice, setIsMinPrice] = useState<number>(0);
  const [minPrice, setMinPrice] = useState<string>('');

  const onChange_name = (event: any) => {
    setName(event.target.value);
  };
  const onChange_discountPrice = (event: any) => {
    setDiscountPrice(getNumberToString(event.target.value));
  };
  const onChange_discountPercent = (event: any) => {
    setDiscountPercent(getNumberToString(event.target.value));
  };
  const onChange_maxDiscount = (event: any) => {
    setMaxDiscount(getNumberToString(event.target.value));
  };
  const onChange_couponCount = (event: any) => {
    setCouponCount(getNumberToString(event.target.value));
  };
  const onChange_minPrice = (event: any) => {
    setMinPrice(getNumberToString(event.target.value));
  };

  // 필수 확인
  const checkRequired = () => {
    if (name.length === 0) return { type: false, comment: '쿠폰명을 입력해주세요' };
    else if (discountType === 0 && discountPrice.length === 0)
      return { type: false, comment: '할인금액을 입력해주세요' };
    else if (discountType === 0 && Number(discountPrice) === 0)
      return { type: false, comment: '할인금액이 0원이에요' };
    else if (discountType === 1 && discountPercent.length === 0)
      return { type: false, comment: '할인률을 입력해주세요' };
    else if (discountType === 1 && Number(discountPercent) === 0)
      return { type: false, comment: '할인률이 0원이에요' };
    else if (discountType === 1 && maxDiscount.length === 0)
      return { type: false, comment: '최대할인금액을 입력해주세요' };
    else if (discountType === 1 && Number(maxDiscount) === 0)
      return { type: false, comment: '최대할인금액이 0원이에요' };
    else if (endDate.getTime() < startDate.getTime())
      return { type: false, comment: '시작시간이 종료시간보다 늦어요' };
    else if (isLimit === 1 && couponCount.length === 0)
      return { type: false, comment: '쿠폰수량을 입력해주세요' };
    else if (isMinPrice === 0 && minPrice.length === 0)
      return { type: false, comment: '최소 주문금액을 입력해주세요' };
    else if (isMinPrice === 0 && Number(minPrice) === 0)
      return { type: false, comment: '최소 주문금액이 0원이에요' };
    return { type: true, comment: '' };
  };

  // API 호출
  const setCouponData = async () => {
    try {
      const checkRequire = checkRequired();
      if (checkRequire.type) {
        const coupon: EditCouponType = {
          store_id: currentStore.value,
          coupon_name: name,
          coupon_type: discountType,
          start_date: moment(startDate).format('YYYY-MM-DD HH:mm:ss'),
          end_date: moment(endDate).format('YYYY-MM-DD HH:mm:ss'),
          is_count_limit: isLimit,
          requirement: isMinPrice === 0 ? Number(minPrice) : 0,
        };
        if (discountType === 0) {
          coupon.price = Number(discountPrice);
        } else {
          coupon.percent = Number(discountPercent);
          coupon.max_discount = Number(maxDiscount);
        }
        if (isLimit === 1) {
          coupon.count_limit = Number(couponCount);
        }
        const oRes = await StoreController.setCoupon(coupon); // test
        if (oRes && oRes.data) {
          const oResponse = oRes.data;
          console.log('setCateProduct', oResponse);
          if (oResponse.data && oResponse.ok) {
            showToast('새로운 쿠폰 정보를 등록했어요');
            navigate(-1);
          }
        }
      } else {
        showToast('필수 정보를 입력해주세요', 'error');
      }
    } catch (err) {
      console.log('err---->', err);
    }
  };

  return (
    <Style>
      <div className="contentContainer">
        <div className="editHeaderWrap">
          <button className="backButton" onClick={() => navigate(-1)}>
            <img src={`${process.env.PUBLIC_URL}/svg/ic_arrow_left.svg`} alt="ic" />
          </button>
        </div>
        <div className="inputText contentWrap">
          <div className="title">
            <h4>쿠폰명</h4>
          </div>
          <input
            type="text"
            placeholder="쿠폰명을 적어주세요"
            value={name}
            onChange={onChange_name}
            autoFocus={true}
          />
        </div>
        <div className="inputText contentWrap">
          <div className="title">
            <h4>할인 방식 선택</h4>
          </div>
          <div className="selectBoxWrap">
            <div
              className={`selectBox left ${discountType === 0 && 'active'}`}
              onClick={() => setDiscountType(0)}>
              정액할인
            </div>
            <div
              className={`selectBox right ${discountType === 1 && 'active'}`}
              onClick={() => setDiscountType(1)}>
              정률할인
            </div>
          </div>
          {discountType === 0 ? (
            <div className="inputWrap">
              <div className="unit">원</div>
              <input
                type="text"
                value={discountPrice}
                placeholder="할인금액을 입력해주세요"
                onChange={onChange_discountPrice}
                autoFocus={false}
              />
            </div>
          ) : (
            <>
              <div className="inputWrap">
                <div className="unit">%</div>
                <input
                  type="text"
                  value={discountPercent}
                  placeholder="할인률을 입력해주세요"
                  onChange={onChange_discountPercent}
                  autoFocus={false}
                />
              </div>
              <div className="inputWrap gap">
                <div className="unit">원</div>
                <input
                  type="text"
                  value={maxDiscount}
                  placeholder="최대 할인 금액을 입력해주세요"
                  onChange={onChange_maxDiscount}
                  autoFocus={false}
                />
              </div>
            </>
          )}
        </div>
        <div className="inputText contentWrap">
          <div className="title">
            <h4>쿠폰 기간</h4>
          </div>
          <div className="calendarRow">
            <div className="calendarWrap">
              <DatePicker
                id="startDate"
                dateFormat="yyyy-MM-dd"
                isClearable={false}
                locale="ko"
                selected={startDate}
                onChange={(e: any) => setStartDate(e)}
                minDate={new Date()}
                disabledKeyboardNavigation={true}
                onFocus={(e) => {
                  e.preventDefault();
                  e.target.blur();
                }}
              />
              <label className="datePicker" htmlFor="startDate">
                <img
                  className="calendar"
                  src={`${process.env.PUBLIC_URL}/svg/ic_calendar.svg`}
                  alt="달력아이콘"
                />
                {moment(startDate).format('YYYY / MM / DD')}
              </label>
            </div>
            <h5>~</h5>
            <div className="calendarWrap">
              <DatePicker
                id="endDate"
                dateFormat="yyyy-MM-dd"
                isClearable={false}
                locale="ko"
                selected={endDate}
                onChange={(e: any) => setEndDate(e)}
                minDate={startDate}
                disabledKeyboardNavigation={true}
                onFocus={(e) => {
                  e.preventDefault();
                  e.target.blur();
                }}
              />
              <label className="datePicker" htmlFor="endDate">
                <img
                  className="calendar"
                  src={`${process.env.PUBLIC_URL}/svg/ic_calendar.svg`}
                  alt="달력아이콘"
                />
                {moment(endDate).format('YYYY / MM / DD')}
              </label>
            </div>
          </div>
        </div>
        <div className="inputText contentWrap">
          <div className="title">
            <h4>쿠폰 수량</h4>
          </div>
          <div className="selectBoxWrap">
            <div
              className={`selectBox left ${isLimit === 1 && 'active'}`}
              onClick={() => setIsLimit(1)}>
              정해진 수량
            </div>
            <div
              className={`selectBox right ${isLimit === 0 && 'active'}`}
              onClick={() => setIsLimit(0)}>
              제한 없음
            </div>
          </div>
          {isLimit === 1 && (
            <div className="inputWrap">
              <div className="unit">개</div>
              <input
                type="text"
                value={couponCount}
                placeholder="쿠폰수량을 입력해주세요"
                onChange={onChange_couponCount}
                autoFocus={false}
              />
            </div>
          )}
        </div>
        <div className="inputText">
          <div className="title">
            <h4>쿠폰 사용 시 최소 주문금액</h4>
          </div>
          <div className="selectBoxWrap">
            <div
              className={`selectBox left ${isMinPrice === 0 && 'active'}`}
              onClick={() => setIsMinPrice(0)}>
              있음
            </div>
            <div
              className={`selectBox right ${isMinPrice === 1 && 'active'}`}
              onClick={() => setIsMinPrice(1)}>
              없음
            </div>
          </div>
          {isMinPrice === 0 && (
            <div className="inputWrap">
              <div className="unit">원</div>
              <input
                type="text"
                value={minPrice}
                placeholder="최소 주문금액을 입력해주세요"
                onChange={onChange_minPrice}
                autoFocus={false}
              />
            </div>
          )}
        </div>

        <button
          className={`submitButton ${!checkRequired().type && 'inactive'}`}
          onClick={setCouponData}>
          저장
        </button>
      </div>
    </Style>
  );
};

export default CouponEdit;

const Style = styled.div`
  .contentContainer:nth-child(1) {
    border-radius: 10px 10px 0 0;
  }
  .contentContainer:nth-child(2) {
    border-radius: 0 0 10px 10px;
  }
  .contentWrap {
    padding-bottom: 4%;
  }
  .editHeaderWrap {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .deleteButton {
      display: flex;
      align-items: center;
      padding: 6px 10px;
      border: 1px solid #40977f;
      border-radius: 5px;
      gap: 10px;
      h5 {
        color: #40977f;
      }
    }
  }

  .calendarRow {
    display: flex;
    gap: 6px;
    align-items: center;
    h5 {
      color: #555555;
      font-weight: 500;
    }
  }

  .calendarWrap {
    flex: 1;
    display: flex;
    position: relative;

    input {
      display: none;
    }

    .calendar {
      position: absolute;
      right: 20px;
      top: 9px;
    }
  }

  .selectBoxWrap {
    display: flex;
    align-items: center;
    padding-bottom: 10px;

    .selectBox {
      flex: 1;
      border: 1px solid #cecece;
      background: #f7f7f7;
      font-size: 14px;
      line-height: 20px;
      color: #555555;
      padding: 8px 0;
      text-align: center;
      cursor: pointer;
    }
    .selectBox.left {
      border-radius: 5px 0px 0px 5px;
      border-right: none;
    }
    .selectBox.right {
      border-radius: 0px 5px 5px 0px;
      border-left: none;
    }
    .selectBox.active {
      border: 1px solid #4dd2ae;
      background: #ecf5f3;
      color: #40977f;
    }
  }

  .inputText {
    .row.gap {
      gap: 10px;
      align-items: flex-end;
    }

    img {
      cursor: pointer;
    }

    .title {
      padding: 30px 0 6px 0;
      display: flex;
      align-items: center;
      gap: 6px;

      h5 {
        color: #40977f;
        font-weight: 500;
      }
      .imageSpan {
        color: #979797;
        font-weight: 400;
      }
      h4 {
        color: #555555;
      }
    }
    .title.initial {
      padding: 0 0 6px 0;
    }

    .inputWrap {
      position: relative;
      .unit {
        position: absolute;
        font-size: 16px;
        line-height: 22px;
        color: #a7a7a7;
        top: 50%;
        transform: translateY(-50%);
        right: 20px;
      }
    }
    .inputWrap.gap {
      margin-top: 10px;
    }
  }

  input,
  textarea {
    width: 100%;
    padding: 10px 12px;
    border: 1px solid #cecece;
    border-radius: 5px;
    color: #555555;
  }

  input::placeholder,
  textarea::placeholder {
    color: #cecece;
  }
`;
